<template>
  <div class="row">
    <el-drawer title="" :visible.sync="showForm" direction="rtl" :before-close="getTickets" size="40%"
      :destroy-on-close="true">
      <refund-ticket-complete-form :refunded="selected" v-if="selected"
        @save="getTickets"></refund-ticket-complete-form>
    </el-drawer>

    <div class="col-md-3 card">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(getTickets)">
          <div class="">
            <div class="card-body">
              <div class="form-group">
                <label>Start Date</label>
                <ValidationProvider name="start_date" rules="required" v-slot="{ passed, failed }">
                  <el-date-picker v-model="start_date" type="date" placeholder="Pick a day" class="form-group" :class="[
                    { 'has-danger': failed },
                    { 'has-success': passed }]">
                  </el-date-picker>
                  <br><span class="error-text" v-if="failed">Start date is required</span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label>End Date</label>
                <ValidationProvider name="end_date" v-slot="{ passed, failed }">
                  <el-date-picker v-model="end_date" type="date" placeholder="Pick a day" class="form-group" :class="[
                    { 'has-danger': failed },
                    { 'has-success': passed }]">
                  </el-date-picker>
                  <br><span class="error-text" v-if="failed">Start date is required</span>
                </ValidationProvider>
              </div>
              <div class="form-group" >
                <label>Ticket Option</label>
                <el-select v-model="option" 
                  class="form-group">
                  <el-option label="ALL" value=""></el-option>
                  <el-option label="ON-SITE TICKETS" value="offline_tickets"></el-option>
                  <el-option label="ONLINE TICKETS" value="online_tickets"></el-option>
                </el-select>
              </div>

              <div class="form-group" v-if="isManagement()">
                <label>Teller</label>
                <el-select v-model="user_id" filterable remote clearable :remote-method="getTellerUsers"
                  class="form-group">
                  <el-option v-for="user in $store.state.users" :key="user.id" :label="user.name" :value="user.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="card-footer text-right">
              <el-button type="info" native-type="button" @click="downloadReport()">Download</el-button>
              <el-button type="info" native-type="submit">Search</el-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <div class="col-md-3">
      <stats-card :type="'danger'" icon="fa fa-sort-amount-desc" :small-title="'Total Refunded Amount'"
        :title="money(total)"></stats-card>
    </div>
    <div class="col-md-3">
      <stats-card :type="'primary'" icon="fa fa-sort-amount-desc" :small-title="'On-site Tickets'"
        :title="onsite_tickets_count"></stats-card>
    </div>
    <div class="col-md-3">
      <stats-card :type="'success'" icon="fa fa-sort-amount-desc" :small-title="'Online Tickets'"
        :title="online_tickets_count"></stats-card>
    </div>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category"><span>Refunded Tickets</span></div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
            <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <el-input placeholder="Search tickets" v-model="term" class="input-with-select" >
                  <el-button slot="append" icon="el-icon-search" type="button" @click="getTickets"></el-button>
                </el-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" header-row-class-name="text-primary" :data="refunded_tickets"
            style="width: 100%">
            <el-table-column :min-width="100" class-name="td-actions" label="Series">
              <template slot-scope="props">
                <div>Series No: {{ props.row.series_number }}</div>
                <div>{{ props.row.ticket.group_code }}</div>
                {{ props.row.ticket.ticket_detail.code }}
              </template>
            </el-table-column>

            <el-table-column :min-width="150" class-name="td-actions" label="Passenger Name">
              <template slot-scope="props">
                {{ props.row.ticket.ticket_detail.passenger.full_name }}
              </template>
            </el-table-column>

            <el-table-column :min-width="60" class-name="td-actions" label="Ticket">
              <template slot-scope="props">
                {{ props.row.ticket.type == 1 ? 'OW' : 'RT' }} {{
                $store.state.passenger_types[props.row.ticket.passenger_type] }}
                <div>                {{ props.row.ticket.booking.route.code }} {{ props.row.ticket.accommodation.code }}
                </div>
              </template>
            </el-table-column>

            <el-table-column :min-width="60" class-name="td-actions" label="Date/Time">
              <template slot-scope="props">
                {{ props.row.ticket.booking.booking_date }}<br> {{ props.row.ticket.booking.formatted_time }}
              </template>
            </el-table-column>
            <el-table-column :min-width="100" class-name="td-actions" label="Ticket Fare">
              <template slot-scope="props">
                <div>FCA:{{ money(props.row.ticket.ticket_detail.fca) }}</div>
                BASE: {{ money(props.row.ticket.ticket_detail.base_fare) }} <br>
                E-VAT: {{ money(props.row.ticket.ticket_detail.evat) }} <br>
                FARE:{{ money(props.row.ticket.ticket_detail.fare) }} <br>
              </template>
            </el-table-column>
         
            <el-table-column :min-width="80" class-name="td-actions" label="Refunded By">
              <template slot-scope="props">
                {{ props.row.user.name }} <br>
                {{ getDateTime(props.row.created_at) }}
              </template>
            </el-table-column>

            <el-table-column :min-width="50" class-name="td-actions" label="Ref %">
              <template slot-scope="props">
                {{ props.row.type_percentage }} %
              </template>
            </el-table-column>

            <el-table-column :min-width="80" class-name="td-actions" label="Refund Amount">
              <template slot-scope="props">
                {{ money(props.row.amount) }}
              </template>
            </el-table-column>

            <el-table-column :min-width="80" class-name="td-actions" label="Charge Amount">
              <template slot-scope="props">
                {{ money(props.row.charge) }}
              </template>
            </el-table-column>

            <el-table-column :min-width="150" class-name="td-actions" label="Action" v-if="can_edit">
              <template slot-scope="props">
                <ConfirmButton v-if="isAllowed('REFUNDED_TICKETS', 'UPDATE')" title="Are you sure you want to un-refund this ticket?"
              icon="fa fa-refresh"
              :type="'danger'"  @onClick="handleEdit(props.row, 'revert')" klass="" size="medium" class="mr-2">
            </ConfirmButton>
                <el-button @click="handleEdit(props.row) && isAllowed('REFUNDED_TICKETS', 'UPDATE')" ><i class="fa fa-edit"></i></el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Found {{ pagination.total }} data</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total="pagination.total">
          </p-pagination>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  Ticket
} from '@/resources/ticket'
import {
  extend
} from "vee-validate";
import {
  required
} from "vee-validate/dist/rules";
import {
  Report
} from '@/resources/report'
import StatsCard from '../../UIComponents/Cards/StatsCard.vue';
import RefundTicketCompleteForm from './RefundTicketCompleteForm.vue';
import ConfirmButton from '../../Common/ConfirmButton.vue';

extend("required", required);

export default {
  components: { StatsCard, RefundTicketCompleteForm, ConfirmButton },
  data() {
    return {
      showForm: false,
      showView: false,
      refunded_tickets: [],
      selected: null,
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      term: null,
      url: null,
      start_date: null,
      end_date: null,
      total: 0,
      option: "",
      onsite_tickets_count: 0,
      online_tickets_count: 0,
      user_id: null,
      can_edit: false
    }
  },
  watch: {
    term: function () {
      if (!this.term || this.term.length > 2) {
        this.getTickets()
      }
    },
    'pagination.perPage': function () {
      if (this.pagination.currentPage == 1) {
        this.getTickets()
      } else {
        this.pagination.currentPage = 1
      }
    },
    'pagination.currentPage': function () {
      this.getTickets()
    }
  },
  created: function () {
    this.start_date = this.$moment().format('YYYY-MM-DD')
    this.end_date = this.$moment().format('YYYY-MM-DD')
    this.getTickets()
    if (this.isManagement()) this.getTellerUsers()

  },
  methods: {
    handleEdit(item, option) {
      this.showForm = true
      this.selected =  Object.assign({}, item)
      this.selected.option = option
    },
    downloadReport() {
      this.$loading = true
      let form = {
        start_date: this.$moment(this.start_date).format('YYYY-MM-DD'),
        end_date: this.$moment(this.end_date).format('YYYY-MM-DD'),
        user_id: this.user_id,
        option: this.option
      }
      Report.getRefundReport(form)
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Report has been generated',
          });
          var printWindow = window.open(result.data.url, '_blank');
          printWindow.print();
        })
        .catch(error => {
        }).finally(() => {
          this.$loading = false
        })
    },
    getDateTime(date) {
      let d = this.$moment(date)
      return d.format('YYYY-MM-DD h:mm a')
    },
    handleClose() {
      this.showForm = false
      this.showView = false
    },
    getTickets() {
      this.handleClose()

      this.start_date = this.$moment(this.start_date).format('YYYY-MM-DD')
      this.end_date = this.$moment(this.end_date).format('YYYY-MM-DD')

      let params = {
        term: this.term,
        status: this.status,
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        start_date: this.start_date,
        end_date: this.end_date,
        user_id: this.user_id,
        option: this.option
      }
      this.$loading = true
      Ticket.refundedTickets(params)
        .then(result => {
          this.can_edit = result.data.can_edit
          this.total = result.data.total
          this.onsite_tickets_count = result.data.onsite_tickets_count
          this.online_tickets_count = result.data.online_tickets_count

          if (result.data.refunded_tickets)
            this.refunded_tickets = result.data.refunded_tickets
          this.pagination = result.data.meta
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>

<style lang="scss"></style>
